'use client';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import type { ConfigItemOption } from '@/app/types';
import { cn } from '@/app/utils';
import { ToolSettingsRadioGroup } from '../../_components/ToolSettingsRadioGroup';

interface OptionProps<T> {
  value?: T;
  onChange: (value: T) => void;
  options: ConfigItemOption[];
}

export const ExtendModelSelection: FC<OptionProps<string>> = ({ value, onChange, options }) => {
  const t = useTranslations();

  return (
    <ToolSettingsRadioGroup
      value={value || 'extendspeed'}
      options={options.map((option) => ({
        value: option.value,
        label: option.label,
        badgeEle: option.remainingTrials ? (
          <div className="-top-3 -right-1 absolute z-index-100 scale-[0.8] rounded-4 bg-gradient-to-t from-[rgba(76,99,255,0.48)] to-[rgba(76,99,255,0.48)] px-[6px] py-1 text-system-white text-xs">
            {t('create.createForm.settings.freeTrials', {
              count: option.remainingTrials,
              s: option.remainingTrials > 1 ? 's' : '',
              es: option.remainingTrials > 1 ? 'es' : '',
            })}
          </div>
        ) : undefined,
      }))}
      onValueChange={(nextValue) => {
        onChange(nextValue);
      }}
      renderContent={(option, isActive) => {
        const config = options.find((item) => item.value === option.value);

        return (
          <div className="flex w-full items-center justify-center gap-2 text-left">
            {config?.icon ? <img src={config.icon} alt="" className="h-8 w-8 flex-shrink-0 rounded-4" /> : null}
            <span
              className={cn(
                'font-medium text-sm leading-[1.4]',
                isActive || !config?.showVip
                  ? 'text-system-white'
                  : 'bg-gradient-to-b from-[#7280FF] via-[#8C97FF] to-[#DADFFF] bg-clip-text text-transparent',
              )}
            >
              {option.label}
            </span>
          </div>
        );
      }}
    />
  );
};
